<template>
  <a class="bnr" href="https://www.toriyasaimiso.jp/shop/" target="_blank">
    <picture>
      <source
        media="(min-width: 768px)"
        srcset="static/assets/images/bnr_ec.png 1x, static/assets/images/bnr_ec@2x.png 2x"
      >
      <source
        media="(min-width: 320px)"
        srcset="static/assets/images/bnr_ec@sp.png"
      >
      <img src="static/assets/images/bnr_ec.png" alt="東村アキコの味噌鍋革命セレクトセット">
    </picture>
  </a>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style lang="scss" scoped>
  .bnr {
    display: block;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(#000, .5);
  }
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue?42beafda